import { FC, ReactNode } from 'react';

type BulkActionBarProps = {
    visible: boolean;
    children: ReactNode;
};

export const BulkActionBar: FC<BulkActionBarProps> = (props) => {
    const { visible, children } = props;

    return (
        <div
            style={{
                overflow: 'hidden',
                maxHeight: visible ? '3rem' : 0,
                visibility: visible ? 'visible' : 'hidden',
                transition: visible
                    ? 'max-height 300ms ease-in-out'
                    : 'max-height 300ms ease-in-out, visibility 0s 300ms',
                backgroundColor: 'white',
            }}
        >
            <div
                style={{
                    height: '3rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    paddingLeft: '1.5rem',
                    opacity: visible ? 1 : 0,
                    pointerEvents: visible ? 'auto' : 'none',
                    transitionProperty: 'opacity',
                    transitionTimingFunction: 'ease-out',
                    transitionDelay: visible ? '200ms' : '0ms',
                    transitionDuration: '200ms',
                }}
            >
                {children}
            </div>
        </div>
    );
};
